import { render, staticRenderFns } from "./downloadModal.vue?vue&type=template&id=72315bec&scoped=true&"
import script from "./downloadModal.vue?vue&type=script&lang=ts&"
export * from "./downloadModal.vue?vue&type=script&lang=ts&"
import style0 from "./downloadModal.vue?vue&type=style&index=0&id=72315bec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72315bec",
  null
  
)

export default component.exports